@if (form) {
<form lin-layout-form [formGroup]="form" (ngSubmit)="installOrUninstall()">
  <div fxLayout="column">
    <div fxLayoutAlign="flex-start center">
      <lin-form-label required class="label">{{ 'ADMIN.DEVICES.IMEI' | translate }}:</lin-form-label>
      <mat-form-field class="form-field">
        <input matInput formControlName="imei" data-testid="input-device-imei" />
        <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
      </mat-form-field>
    </div>

    <div class="info">
      @if (!isClient) {
      <span>{{ 'ADMIN.DEVICES.MODEL' | translate }}: {{ device?.model?.name }}</span>
      }
      <span>{{ 'ADMIN.DEVICES.PHONE_NUMBER' | translate }}: {{ device?.phone }}</span>
      @if (install && device?.deviceInstallation) {
      <span class="lin-form-error">{{ 'ERRORS.DEVICE_INSTALLED' | translate }}</span>
      } @if (!install) {
      <mat-checkbox class="status" formControlName="isUnavailable" data-testid="chk-device-unavailable"
        >{{ 'ADMIN.DEVICES.UNAVAILABLE' | translate }}</mat-checkbox
      >
      } @if (!install && form.controls.isUnavailable.value) {
      <label>{{ 'ADMIN.DEVICES.UNAVAILABLE_MESSAGE' | translate }}:</label>
      <mat-form-field>
        <input matInput formControlName="blockingMessage" autocomplete="off" />
        <mat-error>
          <lin-form-field-error></lin-form-field-error>
        </mat-error>
      </mat-form-field>
      }
    </div>
  </div>

  <div fxLayout="column">
    <div fxLayoutAlign="flex-start center">
      <lin-form-label required class="label">{{ 'ADMIN.DEVICES.VEHICLE_REG_NUMBER' | translate }}:</lin-form-label>
      @if (!vehicleSelect) {
      <mat-form-field class="form-field">
        <input matInput formControlName="regNo" />
        <mat-error><lin-form-field-error></lin-form-field-error></mat-error>
      </mat-form-field>
      } @else {
      <lin-autocomplete-field
        class="form-field"
        formControlName="regNo"
        [displayWith]="displayVehicleRegNo"
        [autocompleteRequest]="getVehicleList"
        [required]="true"
      ></lin-autocomplete-field>
      }
    </div>

    <div class="info">
      @if (!isClient) {
      <span>{{ 'ADMIN.DEVICES.MODEL' | translate }}: {{ vehicle?.model }}</span>
      }
      <span>{{ 'ADMIN.DEVICES.CLIENT' | translate }}: {{ vehicle?.team.clientName }}</span>
    </div>
  </div>

  @if (install) {
  <div class="odometer">
    <label class="label">{{ 'ADMIN.DEVICES.ODOMETER' | translate }}:</label>
    <mat-form-field class="form-field">
      <input matInput type="number" formControlName="odometer" autocomplete="off" min="0" />
      <mat-error>
        <lin-form-field-error></lin-form-field-error>
      </mat-error>
    </mat-form-field>
  </div>
  }

  <lin-form-submit-button
    fxLayoutAlign="center"
    [isDisabled]="!vehicle || !device || (install && device?.deviceInstallation)"
    [isLoading]="isSubmitting"
    data-testid="btn-dialog-confirm"
  >
    {{ (install ? 'ADMIN.DEVICES.INSTALL' : 'ADMIN.DEVICES.UNINSTALL') | translate }}
  </lin-form-submit-button>
</form>
}
